import { render, staticRenderFns } from "./tel-keyboard.vue?vue&type=template&id=f12ddab6&scoped=true&"
import script from "./tel-keyboard.vue?vue&type=script&lang=js&"
export * from "./tel-keyboard.vue?vue&type=script&lang=js&"
import style0 from "./tel-keyboard.vue?vue&type=style&index=0&id=f12ddab6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f12ddab6",
  null
  
)

export default component.exports